import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../index';
import { EmailTemplate } from '../types';

export const useWelcomeTemplate = () => {
  const [data, setData] = useState<EmailTemplate | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchWelcomeTemplate = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await apiClient.get<EmailTemplate | null>('/api/email-templates/welcome');
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch welcome template');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchWelcomeTemplate();
  }, [fetchWelcomeTemplate]);

  return {
    data,
    loading,
    error,
    refetch: fetchWelcomeTemplate,
  };
};